import { z } from 'zod'
import { apiUpload } from './http'

export const MediaImageKindSchema = z.enum(['cover', 'banner', 'bump', 'funnel', 'logo'])
export type MediaImageKind = z.infer<typeof MediaImageKindSchema>

export const MediaUploadResponseSchema = z.object({
  url: z.string(),
  objectKey: z.string(),
  contentType: z.literal('image/webp'),
  width: z.number(),
  height: z.number(),
  sizeBytes: z.number(),
})
export type MediaUploadResponse = z.infer<typeof MediaUploadResponseSchema>

export function uploadMediaImage(
  file: File,
  kind: MediaImageKind,
  options: { onProgress?: (progress: number) => void; signal?: AbortSignal } = {},
): Promise<MediaUploadResponse> {
  const formData = new FormData()
  formData.set('kind', kind)
  formData.set('file', file)
  return apiUpload<unknown>('/media/uploads', formData, options).then((data) =>
    MediaUploadResponseSchema.parse(data),
  )
}
